import clsx from 'clsx';
import { Link } from 'components/Link';
import { HiringHeroProgressbar } from 'features/HiringHeroProgressbar';
import { ArrowRightLongIcon } from 'icons/outline';
import type { HiringHeroStatusbarProps } from './HiringHeroStatusbar.types';
import { AppRoutes } from 'util/urlFactory';
import { useHiringHeroMetric } from 'hooks/redux/useHiringHeroMetric';

export const HiringHeroStatusbar = (props: HiringHeroStatusbarProps) => {
  const { className, actionText, hideStatsLink } = props;
  const { isHiringHero, enabled, metrics, avgProgress } = useHiringHeroMetric();

  if (!enabled) {
    return null;
  }

  const metApplicantRequirements = metrics?.receivedApplicants.met;

  const leftElement = isHiringHero ? (
    <>
      🦸‍♀️ {actionText} to keep your&nbsp;
      <span className="font-bold">Hiring Hero status!</span>
    </>
  ) : (
    <>
      {actionText} to become a&nbsp;
      <span className="font-bold">Hiring Hero</span>
      &nbsp;🦸‍♀️
    </>
  );

  return (
    <div
      className={clsx(
        'px-6 py-3 gap-5 text-sm flex items-center rounded-lg h-[42px] whitespace-nowrap',
        className,
        { 'bg-neutral-no-gray': !isHiringHero, 'bg-tertiary-yellow-300': isHiringHero },
      )}
    >
      <p className="text-neutral-ink-blue">{leftElement}</p>
      {!isHiringHero && (
        <>
          <div className="w-[1px] h-full bg-neutral" />
          <HiringHeroProgressbar value={avgProgress} max={100} className="w-[200px]" />
        </>
      )}

      {!hideStatsLink && (
        <Link
          className="flex items-center gap-1 underline text-neutral-dark last:ml-auto"
          href={AppRoutes.EMPLOYER_HIRING_HERO_STATS_PAGE}
        >
          See my stats
          <ArrowRightLongIcon className="w-6 h-6 text-primary-poppy-red" />
        </Link>
      )}

      {/* comment out for now (no blogpost yet) */}
      {/* {!metApplicantRequirements && (
        <div className="py-3 pr-6 -my-3 -mr-6 bg-white drop-shadow-[0_4px_20px_rgba(0,0,0,0.08)] pl-5 last:ml-auto rounded-lg relative">
          <div className="absolute w-4 h-5 [clip-path:polygon(0%_55%,0%_45%,100%_0%,100%_100%)] -translate-y-1/2 bg-white -left-2 top-1/2"></div>
          <p>
            🤔&nbsp;
            <Link href="#" className="underline text-neutral-dark">
              How can I increase applicants?
            </Link>
          </p>
        </div>
      )} */}
    </div>
  );
};

HiringHeroStatusbar.displayName = 'HiringHeroStatusbar';
